import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import appointmentAPI from '../../sources/api/appointmentAPI';

// constants
import { APPOINTMENT_SHOW } from '../../constants/appointmentTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { appointmentSchema } from '../../schemas/Normalizr';

export function* appointmentShow(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(APPOINTMENT_SHOW, call(appointmentAPI.show, params), appointmentSchema);
  } catch (e) {
    yield put(error(APPOINTMENT_SHOW, e));
  } finally {
    yield put(doneIndicator(APPOINTMENT_SHOW));
  }
}

export function* watchAppointmentShow() {
  yield takeEvery(APPOINTMENT_SHOW, appointmentShow);
}

export default function* root() {
  yield all([
    fork(watchAppointmentShow)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/appointment/appointmentShow.js